import { render, staticRenderFns } from "./DproductIndex.vue?vue&type=template&id=022dbb7e&scoped=true"
import script from "./DproductIndex.vue?vue&type=script&lang=js"
export * from "./DproductIndex.vue?vue&type=script&lang=js"
import style0 from "./DproductIndex.vue?vue&type=style&index=0&id=022dbb7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022dbb7e",
  null
  
)

export default component.exports